import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAutoFlash"><Path d="M14.0019 0.238159L2.25781 16H10.0019V23.7619L21.7461 8.00001H14.0019V0.238159Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M23.1588 23.0001L21.36 14H20.33L14.918 23.0001H16.6803L17.8735 21.0001H21.234L21.6388 23.0001H23.1588ZM20.9339 19.5002H18.7734L20.3938 16.7996L20.9339 19.5002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAutoFlash;
